import { render, staticRenderFns } from "./RSController.vue?vue&type=template&id=1260d324&"
import script from "./RSController.vue?vue&type=script&lang=ts&"
export * from "./RSController.vue?vue&type=script&lang=ts&"
import style0 from "./RSController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports